// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productdisplay{
    display: flex;
    margin: 0px 170px;
}
.productdisplay-left{
    display: flex;
    gap: 17px;
}
.productdisplay-img-list{
    display: flex;
    flex-direction: column;
    gap: 16px;

}
.productdisplay-img-list img{
    height: 163px;

}
.productdisplay-main-img{
    width: 586px;
    height: 700px;
}
.productdisplay-right{
    margin: 0px 70px;
    display: flex;
    flex-direction: column;

}
.productdisplay-right h1{
    color: #3d3d3d;
    font-size: 40px;
    font-weight: 700;
}
.productdisplay-right-stars{
    display: flex;
    align-items: center;
    margin-top: 13px;
    gap: 5px;
    color: #1c1c1c;
    font-size: 16px;
}
.productdisplay-right-prices{
    display: flex;
    margin: 40px 0px;
    gap: 30px;
    font-size: 24px;
    font-weight: 700;


}
.productdisplay-right-price-old{
    color: #818181;
    text-decoration: line-through;
}
.productdisplay-right-price-new{
    color: #ff4141;

}
.productdisplay-right-size h1{
    margin-top: 55px;
    color: #656565;
    font-size: 20px;
    font-weight: 600;
}
.productdisplay-right-sizes{
    display: flex;
    margin: 30px 0px;
    gap: 20px;
}
.productdisplay-right-sizes div{
    padding: 18px 24px;
    background: #fbfbfb;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    cursor: pointer;

}
.productdisplay-right button{
    padding: 20px 40px;
    width: 200px;
    font-size: 16px;
    font-weight: 600;
    color: white;
    background: #ff4141;
    margin-bottom: 40px;
    border: none;
    outline: none;
    cursor: pointer;
}
.productdisplay-right-category{
    margin-top: 10px;
}
.productdisplay-right-category span{
     font-weight: 600;
}

@media(max-width:1280px){
    .productdisplay{
        margin: 0px 60px;
    }
    .productdisplay-left{
        gap: 10px;
    }
    .productdisplay-img-list{
        gap: 10px;
    }
    .productdisplay-img-list img{
        height: 120px;
    }
    .productdisplay-main-img{
        width: auto;
        height: 510px;
    }
    .productdisplay-right{
        margin: 0px 30px;
    }
    .productdisplay-right h1{
        font-size: 22px;
    }
    .productdisplay-right-stars{
        gap: 3px;
        font-size: 13px;
    }
    .productdisplay-right-prices{
        margin: 10px 0px;
        font-size: 18px;
    }
    .productdisplay-right-description{
        font-size: 13px;
    }
    .productdisplay-right-size h1{
        margin-top: 20px;
        font-size: 20px;
    }
    .productdisplay-right-sizes div{
        padding: 14px 20px;
    }
    .productdisplay-right button{
        width: 150px;
        padding: 15px 0px;
        margin-bottom: 20px;
    }
    .productdisplay-right-category{
        margin-top: 5px;
        font-size: 14px;

    }
}
@media(max-width:1024px){
    .productdisplay{
        margin: 0px 30px;
    }
    .productdisplay-left{
        gap: 5px;
    }
    
    .productdisplay-img-list img{
        height: 80px;
    }
    .productdisplay-main-img{
       
        height: 350px;
    }
   
    .productdisplay-right h1{
        font-size: 18px;
    }
    .productdisplay-right-stars img{
       width: 15px;
    }
    
    .productdisplay-right-description{
        font-size: 12px;
    }
    .productdisplay-right-sizes{
        margin-top: 10px 0px;
       
    }
    .productdisplay-right-sizes div{
        padding: 10px 16px;
        font-size: 12px;
    }
    .productdisplay-right button{
        width: 120px;
        padding: 10px 0px;
        margin-bottom: 10px;
        font-size: 14px;
    }
    .productdisplay-right-category{
        
        font-size: 12px;

    }
}
@media(max-width:800px){
    .productdisplay{
        margin: 0px 10px;
    }
    .productdisplay-left{
        gap: 0;
        flex-direction: column-reverse;
        align-items: center;
    }
    
    .productdisplay-img-list{
      
        flex-direction: row;
        gap: 6px;
    }
    .productdisplay-img-list img{
        height: 70px;
        
    }
    .productdisplay-main-img{
       
        height: 300px;
    }
   
    .productdisplay-right h1{
        font-size: 14px;
    }
    .productdisplay-right-stars img{
       width: 13px;
    }
    
    .productdisplay-right-description{
        font-size: 10px;
    }
    .productdisplay-right-size h1{
        margin-top: 10px 0px;
    }
    .productdisplay-right-sizes{
        margin-top: 10px;
        gap: 5px;
       
    }
    .productdisplay-right-sizes div{
        padding: 4px 11px;
       
    }
    .productdisplay-right button{
        width: 100px;
        
        font-size: 12x;
    }
    .productdisplay-right-category{
        
        font-size: 10px;

    }
}
@media(max-width:500px){
    .productdisplay{
        flex-direction: column;
    }
    .productdisplay-left{
        gap: 10px;
        flex-direction: row;
       margin: auto;;
    }
    
    .productdisplay-img-list{
      
        flex-direction: column;
        gap: 8px;
    }
    .productdisplay-img-list img{
        height: 75px;
        
    }
    .productdisplay-main-img{
       
        height: 330px;
    }
    .productdisplay-right{
        margin: 5px;
    }
   
    .productdisplay-right h1{
        margin-top: 15px;

        font-size: 20px;
        font-weight:500;
    }
    .productdisplay-right-stars img{
       width: 15px;
    }
   
    .productdisplay-right-sizes{
       
        gap: 10px;
        margin: 20px 0px;
       
    }
    .productdisplay-right-sizes div{
        padding: 10px 16px;
        font-size: 14px;
       
    }
    .productdisplay-right button{
        width: 130px;
        
        font-size: 15x;
        padding: 12px 0px;
    }
    .productdisplay-right-category{
        
        font-size: 16px;

    }
}`, "",{"version":3,"sources":["webpack://./src/Components/ProductDisplay/ProductDisplay.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;;AAEb;AACA;IACI,aAAa;;AAEjB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;;AAE1B;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,gBAAgB;;;AAGpB;AACA;IACI,cAAc;IACd,6BAA6B;AACjC;AACA;IACI,cAAc;;AAElB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;;AAEnB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;KACK,gBAAgB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;QACX,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,QAAQ;QACR,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,eAAe;;IAEnB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,QAAQ;IACZ;;IAEA;QACI,YAAY;IAChB;IACA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;IACA;OACG,WAAW;IACd;;IAEA;QACI,eAAe;IACnB;IACA;QACI,oBAAoB;;IAExB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;IACnB;IACA;;QAEI,eAAe;;IAEnB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,MAAM;QACN,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;;QAEI,mBAAmB;QACnB,QAAQ;IACZ;IACA;QACI,YAAY;;IAEhB;IACA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;IACA;OACG,WAAW;IACd;;IAEA;QACI,eAAe;IACnB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,QAAQ;;IAEZ;IACA;QACI,iBAAiB;;IAErB;IACA;QACI,YAAY;;QAEZ,cAAc;IAClB;IACA;;QAEI,eAAe;;IAEnB;AACJ;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,SAAS;QACT,mBAAmB;OACpB,YAAY;IACf;;IAEA;;QAEI,sBAAsB;QACtB,QAAQ;IACZ;IACA;QACI,YAAY;;IAEhB;IACA;;QAEI,aAAa;IACjB;IACA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;;QAEhB,eAAe;QACf,eAAe;IACnB;IACA;OACG,WAAW;IACd;;IAEA;;QAEI,SAAS;QACT,gBAAgB;;IAEpB;IACA;QACI,kBAAkB;QAClB,eAAe;;IAEnB;IACA;QACI,YAAY;;QAEZ,cAAc;QACd,iBAAiB;IACrB;IACA;;QAEI,eAAe;;IAEnB;AACJ","sourcesContent":[".productdisplay{\n    display: flex;\n    margin: 0px 170px;\n}\n.productdisplay-left{\n    display: flex;\n    gap: 17px;\n}\n.productdisplay-img-list{\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n}\n.productdisplay-img-list img{\n    height: 163px;\n\n}\n.productdisplay-main-img{\n    width: 586px;\n    height: 700px;\n}\n.productdisplay-right{\n    margin: 0px 70px;\n    display: flex;\n    flex-direction: column;\n\n}\n.productdisplay-right h1{\n    color: #3d3d3d;\n    font-size: 40px;\n    font-weight: 700;\n}\n.productdisplay-right-stars{\n    display: flex;\n    align-items: center;\n    margin-top: 13px;\n    gap: 5px;\n    color: #1c1c1c;\n    font-size: 16px;\n}\n.productdisplay-right-prices{\n    display: flex;\n    margin: 40px 0px;\n    gap: 30px;\n    font-size: 24px;\n    font-weight: 700;\n\n\n}\n.productdisplay-right-price-old{\n    color: #818181;\n    text-decoration: line-through;\n}\n.productdisplay-right-price-new{\n    color: #ff4141;\n\n}\n.productdisplay-right-size h1{\n    margin-top: 55px;\n    color: #656565;\n    font-size: 20px;\n    font-weight: 600;\n}\n.productdisplay-right-sizes{\n    display: flex;\n    margin: 30px 0px;\n    gap: 20px;\n}\n.productdisplay-right-sizes div{\n    padding: 18px 24px;\n    background: #fbfbfb;\n    border: 1px solid #ebebeb;\n    border-radius: 3px;\n    cursor: pointer;\n\n}\n.productdisplay-right button{\n    padding: 20px 40px;\n    width: 200px;\n    font-size: 16px;\n    font-weight: 600;\n    color: white;\n    background: #ff4141;\n    margin-bottom: 40px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n}\n.productdisplay-right-category{\n    margin-top: 10px;\n}\n.productdisplay-right-category span{\n     font-weight: 600;\n}\n\n@media(max-width:1280px){\n    .productdisplay{\n        margin: 0px 60px;\n    }\n    .productdisplay-left{\n        gap: 10px;\n    }\n    .productdisplay-img-list{\n        gap: 10px;\n    }\n    .productdisplay-img-list img{\n        height: 120px;\n    }\n    .productdisplay-main-img{\n        width: auto;\n        height: 510px;\n    }\n    .productdisplay-right{\n        margin: 0px 30px;\n    }\n    .productdisplay-right h1{\n        font-size: 22px;\n    }\n    .productdisplay-right-stars{\n        gap: 3px;\n        font-size: 13px;\n    }\n    .productdisplay-right-prices{\n        margin: 10px 0px;\n        font-size: 18px;\n    }\n    .productdisplay-right-description{\n        font-size: 13px;\n    }\n    .productdisplay-right-size h1{\n        margin-top: 20px;\n        font-size: 20px;\n    }\n    .productdisplay-right-sizes div{\n        padding: 14px 20px;\n    }\n    .productdisplay-right button{\n        width: 150px;\n        padding: 15px 0px;\n        margin-bottom: 20px;\n    }\n    .productdisplay-right-category{\n        margin-top: 5px;\n        font-size: 14px;\n\n    }\n}\n@media(max-width:1024px){\n    .productdisplay{\n        margin: 0px 30px;\n    }\n    .productdisplay-left{\n        gap: 5px;\n    }\n    \n    .productdisplay-img-list img{\n        height: 80px;\n    }\n    .productdisplay-main-img{\n       \n        height: 350px;\n    }\n   \n    .productdisplay-right h1{\n        font-size: 18px;\n    }\n    .productdisplay-right-stars img{\n       width: 15px;\n    }\n    \n    .productdisplay-right-description{\n        font-size: 12px;\n    }\n    .productdisplay-right-sizes{\n        margin-top: 10px 0px;\n       \n    }\n    .productdisplay-right-sizes div{\n        padding: 10px 16px;\n        font-size: 12px;\n    }\n    .productdisplay-right button{\n        width: 120px;\n        padding: 10px 0px;\n        margin-bottom: 10px;\n        font-size: 14px;\n    }\n    .productdisplay-right-category{\n        \n        font-size: 12px;\n\n    }\n}\n@media(max-width:800px){\n    .productdisplay{\n        margin: 0px 10px;\n    }\n    .productdisplay-left{\n        gap: 0;\n        flex-direction: column-reverse;\n        align-items: center;\n    }\n    \n    .productdisplay-img-list{\n      \n        flex-direction: row;\n        gap: 6px;\n    }\n    .productdisplay-img-list img{\n        height: 70px;\n        \n    }\n    .productdisplay-main-img{\n       \n        height: 300px;\n    }\n   \n    .productdisplay-right h1{\n        font-size: 14px;\n    }\n    .productdisplay-right-stars img{\n       width: 13px;\n    }\n    \n    .productdisplay-right-description{\n        font-size: 10px;\n    }\n    .productdisplay-right-size h1{\n        margin-top: 10px 0px;\n    }\n    .productdisplay-right-sizes{\n        margin-top: 10px;\n        gap: 5px;\n       \n    }\n    .productdisplay-right-sizes div{\n        padding: 4px 11px;\n       \n    }\n    .productdisplay-right button{\n        width: 100px;\n        \n        font-size: 12x;\n    }\n    .productdisplay-right-category{\n        \n        font-size: 10px;\n\n    }\n}\n@media(max-width:500px){\n    .productdisplay{\n        flex-direction: column;\n    }\n    .productdisplay-left{\n        gap: 10px;\n        flex-direction: row;\n       margin: auto;;\n    }\n    \n    .productdisplay-img-list{\n      \n        flex-direction: column;\n        gap: 8px;\n    }\n    .productdisplay-img-list img{\n        height: 75px;\n        \n    }\n    .productdisplay-main-img{\n       \n        height: 330px;\n    }\n    .productdisplay-right{\n        margin: 5px;\n    }\n   \n    .productdisplay-right h1{\n        margin-top: 15px;\n\n        font-size: 20px;\n        font-weight:500;\n    }\n    .productdisplay-right-stars img{\n       width: 15px;\n    }\n   \n    .productdisplay-right-sizes{\n       \n        gap: 10px;\n        margin: 20px 0px;\n       \n    }\n    .productdisplay-right-sizes div{\n        padding: 10px 16px;\n        font-size: 14px;\n       \n    }\n    .productdisplay-right button{\n        width: 130px;\n        \n        font-size: 15x;\n        padding: 12px 0px;\n    }\n    .productdisplay-right-category{\n        \n        font-size: 16px;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
